import validate from "/home/runner/work/tripexpert-frontend/tripexpert-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/home/runner/work/tripexpert-frontend/tripexpert-frontend/middleware/redirects.global.js";
export const globalMiddleware = [
  validate,
  redirects_45global
]
export const namedMiddleware = {}